import { useCanAccess, useTranslate } from "ra-core";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

/**
 * Almikia Epic EW3 (TASK-095): the entry links to the 'Sin clasificar' tray and the personal
 * numbers screen. Rendered ONLY for the holder of `sales.can_classify_whatsapp_contacts`
 * (`canAccess` decides); for anyone else it renders nothing, so no link leaks.
 */
export const UnclassifiedNavLinks = ({
  withHeading = false,
}: {
  /** Settings pages: a separator and a section heading above the links. */
  withHeading?: boolean;
}) => {
  const translate = useTranslate();
  const tray = useCanAccess({
    resource: "whatsapp_unclassified",
    action: "list",
  });
  const numbers = useCanAccess({
    resource: "whatsapp_personal_numbers",
    action: "list",
  });
  if (!tray.canAccess && !numbers.canAccess) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {withHeading ? (
        <>
          <Separator className="my-2 w-full" />
          <h3 className="w-full text-lg font-medium text-muted-foreground">
            {translate("crm.whatsapp.unclassified.settings_heading")}
          </h3>
        </>
      ) : null}
      {tray.canAccess ? (
        <Button asChild variant="outline" className="min-h-11">
          <Link to="/whatsapp_unclassified">
            {translate("crm.whatsapp.unclassified.nav")}
          </Link>
        </Button>
      ) : null}
      {numbers.canAccess ? (
        <Button asChild variant="outline" className="min-h-11">
          <Link to="/whatsapp_personal_numbers">
            {translate("crm.whatsapp.numbers.nav")}
          </Link>
        </Button>
      ) : null}
    </div>
  );
};
